
import "../css/PerformanceEvaluation.css"

interface props{
  filtroEstado: string,
  setFiltroEstado: any
}

const FiltroEstadosPerformanceEvaluation = ({filtroEstado, setFiltroEstado}:props) => {

    const cambioEstado = (estado:string) =>{
        setFiltroEstado(estado)
    }
  

  return (
    <>
    <div className="c_contenedorTitulosEstado">
      <div className={`c_tituloProceso ${filtroEstado ==='definicion'? 'c_tituloProcesoSeleccionado': ''}`} onClick={() => cambioEstado('definicion')}>Definición</div>
      <div className={`c_tituloProceso ${filtroEstado ==='evaluacion'? 'c_tituloProcesoSeleccionado': ''}`} onClick={() => cambioEstado('evaluacion')}>Evaluación</div>
      <div className={`c_tituloProceso ${filtroEstado ==='retroalimentacion'? 'c_tituloProcesoSeleccionado': ''}`} onClick={() => cambioEstado('retroalimentacion')}>Retroalimentación</div>
    </div>
    <div className="c_contenedorIconoSeguimiento">
      {

      (filtroEstado === 'definicion' ?
        <>
          <div className="c_circuloAmarillo" onClick={() => cambioEstado('definicion')}>
            <div className="c_circuloBlanco"></div>
          </div>
          <div className="c_lineaSeguimientoP"></div>
          <div className="c_circuloGris" onClick={() => cambioEstado('evaluacion')}></div>
          <div className="c_lineaSeguimientoP"></div>
          <div className="c_circuloGris" onClick={() => cambioEstado('retroalimentacion')}></div>
         
      </>
      :(filtroEstado ==='evaluacion'?
        <>
          <div className="c_circuloGris" onClick={() => cambioEstado('definicion')}></div>
          <div className="c_lineaSeguimientoP"></div>
          <div className="c_circuloAmarillo" onClick={() => cambioEstado('evaluacion')}>
                <div className="c_circuloBlanco"></div>
          </div>
          <div className="c_lineaSeguimientoP"></div>
          <div className="c_circuloGris" onClick={() => cambioEstado('retroalimentacion')}></div>
        </>
      :(filtroEstado ==='retroalimentacion'?
        <>
          <div className="c_circuloGris" onClick={() => cambioEstado('definicion')}></div>
          <div className="c_lineaSeguimientoP"></div>
          <div className="c_circuloGris" onClick={() => cambioEstado('evaluacion')}></div>
          <div className="c_lineaSeguimientoP"></div>
          <div className="c_circuloAmarillo" onClick={() => cambioEstado('retroalimentacion')}>
            <div className="c_circuloBlanco"></div>
          </div>
        </>
        :null
      )))}
    </div>
  </>
  )
}

export default FiltroEstadosPerformanceEvaluation